export default "__VITE_ASSET__ccb9c74f__"